import { authAction } from "../action/authAction";

import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  currentUser: null,
};

const auth = createSlice({
  name: "auth",
  initialState: initialState,
  reducers: authAction,
});

export const { setCurrentUser } = auth.actions;

export default auth.reducer;
